const BASE_URL = '/internalApi/v2/sales-activity/create';
export const CREATE_SALES_ACTIVITY_URL = BASE_URL + '/';
